// localStorage keys
export const STORE_REPEATING_NAME = "repeatingNameProgress";
export const STORE_DARK_MODE = "darkMode";

// Rosary Companion spacing
export const IMAGE_TEXT_GAP = "40px";
export const MOBILE_IMAGE_TEXT_GAP = "5px";
export const MYSTERY_GAP = "20px";
export const MOBILE_MYSTERY_GAP = "60px";

// Bulletin Viewer spacing
export const BULLETIN_GAP = "60px";
export const MOBILE_BULLETIN_GAP = "60px";